// extracted by mini-css-extract-plugin
export var compactFilters = "_fa-4";
export var detailImage = "_fa-1";
export var dropdownContainer = "_fa-2";
export var imageContainer = "_fa-0";
export var selectedCard = "_fa-3";